import styled from "styled-components";

export const WhyChooseUsStyle = styled.article`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;


